import { atom, selector } from "recoil";
import { MyBEE123HomepageService } from "../Component/Api/MyBEE123HomePage/MyBEE123HomepageService";
import { ScorecardMeta } from "../Component/Model/Dto/Scorecard/ScorecardMeta";
import { UserAtom } from "./user.Atom";
import { isNullOrEmpty } from "../Component/Model/helpers";



export const allScorecardState = selector<ScorecardMeta.ScorecardMetaViewModel[]> ({
    key: "allScorecardState",
    get: async ({ get }) => {
        const user = get(UserAtom);

        if (isNullOrEmpty(user.username)) {
            return []
        }; 
        
        try {
            const response = await MyBEE123HomepageService.getEEUserScorecards();
            return response.data || [];
        } catch (error) {
            console.error(`Error: \n${error}`)
            return [];
        }
    }
});

export const ScorecardListState = atom<ScorecardMeta.ScorecardMetaViewModel[]>({
    key: "ScorecardListState",
    default: allScorecardState
})
